/**
Project: Voice Panel (c)
Title: Control Tab  
Description: settings related tab to select the department/number types/carriers
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React from 'react';
import { NavLink } from "react-router-dom";
import { VoiceAdminURLProps } from "../../common/settings/voice-admin-urls";
import IntlUtil from "../../../../core/helpers/intl-util";

export const ControlTab = (intlNamespace) => [
    {
        key: 'departments',
        to: VoiceAdminURLProps.controlDepartments,
        content: IntlUtil.getText(intlNamespace, "content.departments"),
        children: itemRenderer,
    },
    {
        key: 'numberTypes',
        to: VoiceAdminURLProps.controlNumbertypes,
        content: IntlUtil.getText(intlNamespace, "content.numberTypes"),
        children: itemRenderer,
    },
    {
        key: 'carriers',
        to: VoiceAdminURLProps.controlCarriers,
        content: IntlUtil.getText(intlNamespace, "content.carriers"),
        children: itemRenderer,
    },
    {
        key: 'deviceTypes',
        to: VoiceAdminURLProps.controlDevicetypes,
        content: IntlUtil.getText(intlNamespace, "content.deviceTypes"),
        children: itemRenderer,
    },
]

const itemRenderer = (MenuItem, props) => {
    const { to, ...rest } = props
    return (
        <MenuItem as={NavLink} to={to} className="nav-link" {...rest} />
    )
}